export const UNEXPECTED_ERROR_MESSAGE: string = 'An unknown error occurred. We have been notified instantly.';
export const GENERAL_VALIDATION_FAIL_MESSAGE: string = 'Please make sure you filled all of the fields correctly.';
export const GENERAL_ERROR_MESSAGE: string = 'An unknown error occurred. Please try again later.';
export const GENERAL_SUCCESS_MESSAGE: string = 'Changes saved successfully.';

